export default "__VITE_ASSET__cfda6221__"